import { formatUnits } from "viem"

import type { ApprovalMode, ContractRiskLevel } from "@/domains/core"

/**
 * If the user has chosen infinite approvals via ApprovalMode then return max int 256
 * If the user has chosen strict approvals via ApprovalMode then return the amount
 * If the contract is immutable then return max int 256
 * Otherwise return the amount
 *
 * @param amount
 * @param mode
 * @param riskLevel
 * @returns
 */
export const determineApprovalAmount = (amount: bigint, mode: ApprovalMode, riskLevel: ContractRiskLevel): bigint => {
  if (mode === "infinite") {
    return BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff")
  }
  if (mode === "strict") {
    return amount
  }
  if (riskLevel === "immutable") {
    return BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff")
  }
  return amount
}

export const makeApprovalDescription = (amount: bigint, decimals: number): string => {
  if (amount === BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff")) {
    return "Seeking max approval"
  }
  if (amount > BigInt("0xfffffffffffffffffffffffffff")) {
    return "Seeking large approval"
  }

  return `Seeking approval of ${formatUnits(amount, decimals)}`
}
